export const AUTH_TOKEN_KEY = 'AUTH_TOKEN';
export const AUTH_TOKEN_EXPIRED_AT = 'AUTH_TOKEN_EXPIRED_AT';
export const BETSLIP_ID_BACKUP = 'BETSLIP_ID_BACKUP';